class ParametricFilterMortgage {
    constructor(options) {
        this.options = options;
        this.element = options.element;
        this.openClass = 'is-open';
    }

    init() {
        if (!this.element) {
            return;
        }

        this._initElements();
        this._bindEvents();
        $(this.content).slideUp(0);
    }

    _initElements() {
        this.check = this.element.querySelector('.j-parametric-filter__mortgage-check');
        this.content = this.element.querySelector('.j-parametric-filter__dropdown');
    }

    _bindEvents() {
        this.check.addEventListener('change', () => {
            this._toggleState();
        });
    }

    _toggleState() {
        this[this.check.checked ? 'open' : 'close']();
    }

    /**
     * Открыть
     */
    open() {
        this.element.classList.add(this.openClass);
        $(this.content).slideDown(300, () => {
            if (this.options.update) {
                this.options.update();
            }
        });
    }

    /**
     * Закрыть
     */
    close() {
        $(this.content).slideUp(300, () => {
            if (this.options.update) {
                this.options.update();
            }
        });
        this.element.classList.remove(this.openClass);
    }

    /**
     * Обновление компонента снаружи
     */
    update() {
        this._toggleState();
    }
}

export default ParametricFilterMortgage;
